import { render } from "./TermsPage.vue?vue&type=template&id=2493f4ad"
import script from "./TermsPage.vue?vue&type=script&lang=js"
export * from "./TermsPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__